<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <change-school ref="changeSchool"></change-school>
  </div>
</template>

<script>
import { getToken } from '@/utils/token'
import ChangeSchool from './components/ChangeSchool'

export default {
  name: 'App',
  components: { ChangeSchool },
  data () {
    return {
    }
  },
  created () {
    this.$store.dispatch('GetConfig')
    if (getToken()) {
      this.$store.dispatch('GetUserInfo').catch(() => {
        this.$store.dispatch('LogOut')
      })
    }
  }
}
</script>

<style>
#app {
  font-family: "SourceHanSansCN", "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue